import { ClubJoinBlock } from 'cms-types'
import { type LoadableComponentProps } from 'ui'

import { ClubJoinClient } from './ClubJoinClient'

function ClubJoin(props: LoadableComponentProps<ClubJoinBlock>) {
  // The join UI decides its own visibility from client-side membership, so it
  // contributes no server/suspense skeleton (avoids flashing it at members).
  if (props.loading) return null

  return <ClubJoinClient data={props.data} />
}

export default ClubJoin
ClubJoin.loadable = true
